var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section section--shadowed"},[_c('gmap-map',{attrs:{"id":"map","center":_vm.center,"zoom":_vm.zoom}},[_c('gmap-marker',{attrs:{"position":_vm.markerPosition,"clickable":false,"icon":_vm.markerImage}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }